/*
 *  File: token.service.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';

/**
 *
 * @author dlolugu1271
 * @description This is a service class which generates the IDS token 
 * to further interact with subscription engine APIs.
 * 
 */
@Injectable()
export class TokenService {

  constructor(private http: HttpClient) { }

  public tokenRes: any;

  /**
   *
   * @author dlolugu1271
   * @description This method which generates the IDS token from API gateway
   * to further interact with subscription engine APIs.
   * 
   */
  login() {
    try {
      let options = { headers: new HttpHeaders({ 'x-api-key': environment.appextconfig.api_key }) };
      this.http.get(environment.appextconfig.api_gateway_url + '/fetchmetadata', options)
        .timeout(environment.appextconfig.api_timeout_limit)
        //.retry(environment.appextconfig.api_retry_limit)
        .subscribe(
        res => {
          this.tokenRes = res;
          if (this.tokenRes.token) {
            localStorage.setItem('token', this.tokenRes.token);
          } else {
            localStorage.setItem('token', '');
          }
        },
        error => {
          localStorage.setItem('token', '');
          //console.error('**Error**', error);
        });
      } catch(error) {
        //console.error('**Error**', error);
        localStorage.setItem('token', '');
      }
  }
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/services/token.service.ts